<template>
  <label class="ui-field">
    <span v-if="label" class="label">{{ label }}</span>
    <input
      class="ui-input"
      :type="type"
      :placeholder="placeholder"
      v-model="innerValue"
      :inputmode="inputmode"
      :autocomplete="autocomplete"
      :maxlength="maxlength"
    />
  </label>
</template>

<script>
export default {
  name: "UiInput",
  props: {
    modelValue: { type: [String, Number], default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    type: { type: String, default: "text" },
    inputmode: { type: String, default: "" },
    autocomplete: { type: String, default: "off" },
    maxlength: { type: [Number, String], default: null },
  },
  computed: {
    innerValue: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
  },
};
</script>

<style scoped>
.ui-field {
  display: grid;
  gap: 8px;
  width: 100%;
}

.ui-input {
  height: 54px;
  border-radius: 5px;
  border: 1px solid transparent;
  background: #151718;
  color: #fff;
  padding: 0 14px;
}

.ui-input::placeholder {
  color: var(--text-dim);
}

.ui-input:focus {
  outline: none;
  border-color: rgba(120, 255, 71, 0.6);
  box-shadow: 0 0 0 3px rgba(120, 255, 71, 0.15);
}
</style>
